import { useQuery, useMutation } from '@tanstack/react-query'
import { Conflict } from '../../shared/types'
import { ButtonLink } from '../components/button'
import { get, put } from '../fetch'

export function useReservationListConflicts() {
	return useQuery({
		queryKey: ['api/reservation/conflicts'],
		queryFn: () => get<Array<Conflict>>(`/api/0/reservation/conflicts`),
		select: data => {
			return {
				total: data.length,
				list: data,
			}
		},
	})
}

export function useReservationGetConflicts(id: string) {
	return useQuery({
		queryKey: ['api/reservation/conflicts', id],
		queryFn: () =>
			get<Array<Omit<Conflict, 'conflict_with'>>>(`/api/0/reservation/${id}/conflicts`),
		select: data => {
			return {
				total: data.length,
				list: data,
			}
		},
	})
}

export function useReservationCreate() {
	return useMutation({
		mutationFn: (data: FormData) => put<string>(`/api/0/reservation`, data),
		meta: {
			invalidateQueries: [['api/reservation'], ['api', 'reservation'], ['api/dashboard']],
			notifications: {
				success: id => (
					<div className="flex items-center justify-between gap-4">
						Rezervace vytvořena
						<ButtonLink to={`/svc/reservation/${id}`} size="SMALL" variant="SECONDARY">
							Zobrazit
						</ButtonLink>
					</div>
				),
			},
		},
	})
}
